import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]

import { ref, withDefaults } from "vue";
interface IPropOptions {
  id: number;
  label?: string | number;
  value: string | number;
  isSelected: boolean | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmSegmentControl',
  props: {
    options: {},
    value: {},
    isRounded: { type: Boolean },
    size: { default: "default" }
  },
  emits: ["select"],
  setup(__props: any, { emit }) {

const props = __props;





const localOptions = ref<Array<IPropOptions>>(props.options);

let onSelect = (option: IPropOptions) => {
  localOptions.value.forEach((elem) => {
    elem.isSelected = false;
  });
  let indexUpdateOption = localOptions.value.findIndex((x) => x.id == option.id);
  localOptions.value[indexUpdateOption].isSelected = true;

  console.log(localOptions.value[indexUpdateOption].value);

  emit("select", localOptions.value[indexUpdateOption].value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["segmented-control", {
      'segmented-control--rounded': props.isRounded,
      'segmented-control--medium': props.size == 'medium',
    }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localOptions.value, (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["segmented-control__item", {
        'segmented-control__item--is-selected': option.isSelected,
      }]),
        key: index,
        onClick: ($event: any) => (_unref(onSelect)(option))
      }, _toDisplayString(option.label), 11, _hoisted_1))
    }), 128))
  ], 2))
}
}

})